/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslocoModule } from '@jsverse/transloco';

import { AvatarModule } from '../avatar/avatar.module';
import { MenusModule } from '../menus/menus.module';
import { SVGIconModule } from '../svg-icon/svg-icon.module';
import { UtilsModule } from '../../utils/utils.module';
import { BulbPageViewTranslationProvider } from './translation-provider';

import { CoverImageComponent } from './cover-image/cover-image.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { HeaderEffectsDirective } from './header-effects.directive';
import { HttpService } from './http.service';
import { ContenteditableSupportDirective } from './input-directives/contenteditable-support.directive';
import { ContenteditableValueAccessorDirective } from './input-directives/contenteditable-value-accessor.directive';
import { HeaderImageComponent } from './header-image/header-image.component';
import { HeaderImageControlsComponent } from './header-image-controls/header-image-controls.component';
import { ResizeObserverDirective } from './page-header/directives/resize-observer.directive';
import { AeroModule } from '../../aero/aero.module';
import { BulbCommonModule } from '../../common/bulb-common.module';

/**
 * A module for collecting all page view related components and directives.
 */
@NgModule({
  declarations: [
    ContenteditableSupportDirective,
    ContenteditableValueAccessorDirective,
    HeaderEffectsDirective,
    PageHeaderComponent,
    CoverImageComponent,
    HeaderImageComponent,
    HeaderImageControlsComponent,
    ResizeObserverDirective,
  ],
  exports: [
    PageHeaderComponent,
  ],
  imports: [
  // Angular Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UtilsModule,
    // Bulb Modules
    AvatarModule,
    MenusModule,
    SVGIconModule,
    // Other Modules
    TranslocoModule,
    AeroModule,
    BulbCommonModule],
  providers: [
    HttpService,
    BulbPageViewTranslationProvider,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class PageViewModule { }
